import { loadStripe, type Stripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

// For Direct Charges via Connect, Stripe.js must be initialized with the
// connected account's ID via the `stripeAccount` option. Cached per account.
const stripeConnectCache = new Map<string, Promise<Stripe | null>>();

export function getStripeForConnect(stripeAccount: string | null): Promise<Stripe | null> {
  if (!stripeAccount) return stripePromise;
  if (!stripeConnectCache.has(stripeAccount)) {
    stripeConnectCache.set(
      stripeAccount,
      loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY, { stripeAccount })
    );
  }
  return stripeConnectCache.get(stripeAccount)!;
}
